<template>
  <div>
    <van-field
      v-model="s2.DispName"
      label="餐點備註"
      autosize
      type="textarea"
      maxlength="20"
      placeholder="请输入留言"
      show-word-limit
      label-align="top"
      @blur="onChange"
    />
  </div>
</template>

<style scoped>
.van-checkbox {
  min-height: 3rem;
}
</style>

<script>
export default {
  props: {
    s2: Object,
  },
  methods: {
    onChange(pEvent) {
      // this.$emit("change", this.s2);
      let value = pEvent.target._value;
      if (value == "") this.s2.Qty = 0;
      else this.s2.Qty = 1;
      this.s2.ItemName = "餐點備註:" + value;
      // this.s2.ItemName = pVal
    },
    // isStopSale(itemname) {
    //   const find = this.$store.state.sStopSale.find(
    //     (r) => r.ItemName == itemname
    //   );
    //   return find;
    // },
  },
};
</script>
